import React from 'react';
import { Grid, GridProps } from '@material-ui/core';

interface Props {
	children: React.ReactNode;
	gridProps?: GridProps;
	gridItemProps?: GridProps;
}

const SimpleGrid: React.FC<Props> = ({ children, gridProps, gridItemProps }) => (
	<Grid
		spacing={1}
		container
		direction="row"
		justify="space-around"
		alignItems="flex-start"
		wrap="wrap"
		{...gridProps}
	>
		{React.Children.map(children, (item) => (
			<Grid {...gridItemProps} item>
				{item}
			</Grid>
		))}
	</Grid>
);

export default SimpleGrid;
